import axios from "axios";

const BASE_URL = "https://zola.technology/api";

// Helper to get token from localStorage
const getAuthHeaders = () => {
  const token = localStorage.getItem("token"); // Adjust this key if needed
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const adminPricingService = {
  // === Features ===

  // Add new feature
  addFeature: async (featureData) => {
    const response = await axios.post(
      `${BASE_URL}/admin/features/add/`,
      featureData,
      getAuthHeaders()
    );
    return response.data;
  },

  // List all features
  getFeatures: async (page = 1, pageSize = 10) => {
    const response = await axios.get(`${BASE_URL}/admin/features/list/`, {
      ...getAuthHeaders(),
      params: { page, page_size: pageSize },
    });
    return response.data;
  },

  // Update feature by ID
  updateFeature: async (featureId, updatedData) => {
    const response = await axios.patch(
      `${BASE_URL}/admin/features/${featureId}/update/`,
      updatedData,
      getAuthHeaders()
    );
    return response.data;
  },

  // === Packages ===

  // Add new package
  addPackage: async (packageData) => {
    const response = await axios.post(
      `${BASE_URL}/admin/packages/add/`,
      packageData,
      getAuthHeaders()
    );
    return response.data;
  },

  // Update package by ID
  updatePackage: async (packageId, updatedData) => {
    const response = await axios.patch(
      `${BASE_URL}/admin/packages/${packageId}/update/`,
      updatedData,
      getAuthHeaders()
    );
    return response.data;
  },

  // Update package features by ID
  updatePackageFeatures: async (packageId, featuresData) => {
    const response = await axios.patch(
      `${BASE_URL}/admin/packages/${packageId}/features/update/`,
      featuresData,
      getAuthHeaders()
    );
    return response.data;
  },

  // List packages
  getPackages: async (page = 1, pageSize = 100) => {
    const response = await axios.get(`${BASE_URL}/public/packages/list/?frequency=yearly`, {
      ...getAuthHeaders(),
      params: { page, page_size: pageSize },
    });
    return response.data;
  },
};

export default adminPricingService;
